import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const dashboardAPI = createApi({
    reducerPath: 'dashboardAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getPositionSummaryByStatus: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.POSITION_SUMMARY_BY_STATUS,
                method: 'POST',
                data,
            }),
        }),
        getChangeRequestSummaryByStatus: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CR_SUMMARY_BY_STATUS,
                method: 'POST',
                data,
            }),
        }),
        getPositionMappingSummaryByStatus: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.POSITION_MAPPING_SUMMARY_BY_STATUS,
                method: 'POST',
                data,
            }),
        }),
        getRecruitmentPolicySummary: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.POSITION_RECRUITMENT_POLICY_MAPPING_SUMMARY,
                method: 'POST',
                data,
            }),
        }),
        getPositionClosureSummary: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.POSITION_CLOSURE_SUMMARY_BY_STATUS,
                method: 'POST',
                data,
            }),
        }),
        getPositionsMappedToChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.GET_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetPositionSummaryByStatusMutation,
    useGetChangeRequestSummaryByStatusMutation,
    useGetPositionMappingSummaryByStatusMutation,
    useGetRecruitmentPolicySummaryMutation,
    useGetPositionClosureSummaryMutation,
    useGetPositionsMappedToChangeRequestPolicyMutation,
} = dashboardAPI;
